import { ApiAddress } from '../apis'
import request from '../request'

export module ChemicalComponent {
  export interface Base {
    id: number
    name: string
    formula: string
  }
  export interface Modal extends Base {
    cas: string
    inchi: string
    inchiKey: string
    pc: number
    tc: number
    af: number
    mw: number
    hf0Gasformation: number
    sf0Gasformation: number
    hf0Liqformation: number
    sf0Liqformation: number
    hsIdGasPoly5: HSIdGasPoly5Parameters
    ant5: Ant5Parameters
    prTwu: PRTwuParameters
  }

  interface HSIdGasPoly5Parameters {
    a_h: number
    a_s: number
    b: number
    c: number
    d: number
    e: number
    f: number
    tmin: number
    tmax: number
  }

  interface Ant5Parameters {
    a5: number
    b5: number
    c5: number
    d5: number
    e5: number
    f5: number
    tmin: number
    tmax: number
  }

  interface PRTwuParameters {
    c0: number
    c1: number
    c2: number
  }

  export module AdminService {
    export function get(params?): Promise<Modal[]> {
      return request.get(ApiAddress.ADMIN_COMPONENTS, { params })
    }

    export function getOne(params?): Promise<Modal> {
      return request.get(ApiAddress.ADMIN_COMPONENT, { params })
    }

    export function create(component: Modal) {
      return request.post(ApiAddress.ADMIN_COMPONENTS, component)
    }

    export function update(id: number, component: Modal) {
      return request.put(ApiAddress.ADMIN_COMPONENT, component, { params: { id } })
    }

    export function remove(id: number) {
      return request.delete(ApiAddress.DELETE_COMPONENT, { params: { id } })
    }
  }

  export module OrganizationService {
    export function get(orgId: number, params?): Promise<Modal[]> {
      return request.get(ApiAddress.ORGANIZATION_COMPONENTS, { params: { orgId, ...params } })
    }

    export function getOne(orgId: number, params?): Promise<Modal> {
      return request.get(ApiAddress.ORGANIZATION_COMPONENT, { params: { orgId, ...params } })
    }

    export function create(orgId: number, component: Modal) {
      return request.post(ApiAddress.ORGANIZATION_COMPONENTS, component, { params: { orgId } })
    }

    export function update(orgId: number, id: number, component: Modal) {
      return request.put(ApiAddress.ORGANIZATION_COMPONENT, component, { params: { orgId, id } })
    }

    export function remove(orgId: number, id: number) {
      return request.delete(ApiAddress.ORGANIZATION_COMPONENT, { params: { orgId, id } })
    }
  }

  export function get(params): Promise<Modal[]> {
    return request.get(ApiAddress.COMPONENTS, { params })
  }

  export function create(component: Modal, params) {
    return request.post(ApiAddress.COMPONENTS, component, { params })
  }

  export function update(component: Modal, params) {
    return request.put(ApiAddress.COMPONENT, component, { params: params })
  }

  export function remove(id: number) {
    return request.delete(ApiAddress.DELETE_COMPONENT, { params: { id } })
  }

  export function getAll(params): Promise<Modal[]> {
    return request.get(ApiAddress.ALL_COMPONENTS, { params })
  }
}
